import { useQuery } from '@apollo/client';
import { ITravelCoupon } from '@flight-workspace/common-client/src/types/travelUser';
import GET_TRAVEL_USER from './travelUser.gql';

interface IData {
  nickname: string;
  coupons: ITravelCoupon[];
  isBiztripUser: boolean;
}

const useTravelUser = () => {
  const { loading, data } = useQuery<IData>(GET_TRAVEL_USER);
  return {
    loading,
    nickName: data?.nickname,
    coupons: data?.coupons,
    isBiztripUser: data?.isBiztripUser,
  };
};

export default useTravelUser;
